import * as React from 'react';
import { IChannel } from '../../../../data/api/models';

interface ICookieAndPrivacy {
  onClickEvent: any;
  channel: IChannel;
}

class CookieAndPrivacy extends React.Component<ICookieAndPrivacy> {
  public render() {
    const { onClickEvent, channel } = this.props;
    let cookiesUrl =  'https://opentrav.mavrikk.co.uk/privacy-cookies/';

    if (['npo-b2c', 'npor-b2c'].includes(channel.key)) {
      cookiesUrl = 'https://www.narpotravelcover.org.uk/privacy-cookies/';
    }

    if (['cspa-b2c', 'cspar-b2c'].includes(channel.key)) {
      cookiesUrl = 'https://www.cspatravelcover.org.uk/privacy-cookies/';
    }

    if (['css-b2c', 'cssr-b2c'].includes(channel.key)) {
      cookiesUrl = 'https://www.combinedservicestravelcover.org.uk/privacy-cookies/';
    }

    if (['camc-b2c'].includes(channel.key)) {
      cookiesUrl = 'https://www.pjhayman.com/cookie-policy/';
    }

    return (
      <div className="cookie-and-privacy-container">
        <div className="container">
          <div className="cookie-and-privacy-message">
            Please click here to view our {' '}
            <a href={cookiesUrl} target="_blank" rel="noopener noreferrer">
              <u>Cookie Policy</u>
            </a>.
            Cookies are used to ensure we provide the best customer experience.
            Continued use of this website assumes your acceptance of these policies.
          </div>
          <div className="cookie-and-privacy-btn" onClick={onClickEvent}>
            <div className="cookie-btn-content">
              {/*<MdCheck />*/}
              <span>
                OK
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CookieAndPrivacy;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/components/CookieAndPrivacy/index.tsx